export default {
  imageloader: 'imageloader.e-domizil.de',
  CDN: '//cdn.e-domizil.de',
  objectImagesWebp: true,
  objectImageGallery: 'grid'
};
